import { Link } from "react-router-dom";
import { tipoIcon } from "@/config/equipamentos";

const Row = ({ e }) => {
  const Icon = tipoIcon(e.tipo);
  return (
    <Link to={`/equipamentos/${e.equipamento_id}`} data-testid={`tree-node-${e.equipamento_id}`}
      className="flex items-center gap-3 min-h-[56px] rounded-xl px-3 hover:bg-[#E8F5E9] transition-colors">
      <span className="h-10 w-10 rounded-lg bg-[#E8F5E9] text-[#1E4D2B] flex items-center justify-center shrink-0"><Icon className="h-5 w-5" /></span>
      <span className="min-w-0 flex-1">
        <span className="block font-semibold truncate">{e.titulo}</span>
        <span className="block text-xs text-[#5C6B66]">{e.codigo}</span>
      </span>
    </Link>
  );
};

const flatten = (items) => {
  const ids = new Set(items.map((i) => i.equipamento_id));
  const byParent = {};
  items.forEach((i) => {
    const p = i.parent_id && ids.has(i.parent_id) ? i.parent_id : "root";
    (byParent[p] = byParent[p] || []).push(i);
  });
  const out = [];
  const stack = [...(byParent.root || [])].reverse().map((e) => [e, 0]);
  while (stack.length) {
    const [e, depth] = stack.pop();
    out.push({ e, depth });
    [...(byParent[e.equipamento_id] || [])].reverse().forEach((k) => stack.push([k, depth + 1]));
  }
  return out;
};

export const EquipTree = ({ items }) => (
  <ul className="space-y-1" data-testid="equip-tree">
    {flatten(items).map(({ e, depth }) => (
      <li key={e.equipamento_id} style={{ marginLeft: Math.min(depth, 6) * 20 }} className={depth ? "border-l-2 border-[#E2DDD3] pl-2" : ""}>
        <Row e={e} />
      </li>
    ))}
  </ul>
);
